




















import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { Mobile } from "@/mixins/mobile";
@Component
export default class QtyPickerCart extends mixins(Mobile) {
  @Prop() index!: number | string | undefined;
  @Prop() passedQty!: number | undefined;
  @Prop({ default: false }) allowZero!: boolean;
  private qty = this.allowZero ? 0 : 1;

  @Watch("passedQty", { immediate: true })
  udpateQty(): void {
    if (this.passedQty) {
      this.qty = this.passedQty;
    }
  }
  // created() {
  //   if (this.passedQty) {
  //     this.qty = this.passedQty;
  //   }
  // }

  protected minus(): void {
    const num = this.allowZero ? 0 : 1;
    if (this.qty > num) {
      this.qty--;
      this.$emit("sendQty", this.qty, this.index);
    }
  }

  protected add(): void {
    if (this.qty < 1000) {
      this.qty++;
      this.$emit("sendQty", this.qty, this.index);
    }
  }
}
